<template>
  <div  class="register-wrapper">
    <h1>{{ $t('Edit your account') }}</h1>
    <form @submit.prevent="submit">
      <label>
        <span  class="requare">{{ $t('First name') }}</span>
        <input  @keyup="keyup" type="text" v-model="form.firstName" name="firstName" placeholder="First name" />
      </label>
      <label>
        <span  class="requare">{{ $t('Last name') }}</span>
        <input  @keyup="keyup" type="text" v-model="form.lastName" name="lastName" placeholder="Last name" />
      </label>
      <label>
        <span  class="requare">{{ $t('Login') }}</span>
        <input  @keyup="keyup" type="email" v-model="form.email" name="email" placeholder="name@email.com" />
      </label>
      <label class="specialization-label">
        <span  class="requare">{{ $t('Specialization') }}</span>
        <div class="select-wrapper">
          <select @change="keyup" v-model="form.specialization" name="specialization">
            <option value="Ophthalmologist">{{ $t('Ophthalmologist') }}</option>
          </select>
        </div>
      </label>
      <label>
        <span  class="requare">{{ $t('Password') }}</span>
        <input  @keyup="keyup" v-model="form.password" name="password" type="password" />
      </label>
      <label>
        <span  class="requare">{{ $t('Repeat Password') }}</span>
        <input  @keyup="keyup" v-model="form.repeatPassword" name="repeatPassword" type="password" />
      </label>


      <div class="error-login" v-show="showError">{{form.error}}</div>
      <button type="submit" class="button-blue">{{ $t('Save') }}</button>
      <button type="submit" @click="cancel" class="button-blue">{{ $t('Cancel') }}</button>
    </form>
   </div>
</template>
<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";

export default {
  name: "Register",
  components: {},
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        password: "",
        email: "",
        specialization: "",
        repeatPassword: "",
        error:''
      },
      showError: false
    };
  },
  methods: {
    ...mapActions(["EditUser","getUser"]),
    keyup(){
      this.showError=false
    },
    cancel(e){
      e.preventDefault();
      this.$router.push("/mainContent");
    },
    async submit() {
      try {
        console.log(this.form)
        let res = await this.EditUser(this.form);
        if(!res.data.result.error) {
          this.$router.push("/mainContent");
          this.showError = false
        }else{
          console.log(res)
          this.form.error = res.data.result.error
          this.showError = true
        }
      } catch (error) {
        console.log(error.response)
        this.form.error = error.response.data.message
        this.showError = true
      }
    },
  },
  async mounted() {
    let res = await this.getUser(this.form);
    let user = res.data.result.user
    this.form.firstName = user.firstName
    this.form.lastName = user.lastName
    this.form.email = user.login
    this.form.specialization = user.specialization
    i18n.locale = this.$store.state.locale

  }
};
</script>

<style>
.error-login{
  margin-top: 10px;
  width: 100%;
  text-align: center;
  color: red;
  font-size: 14px;
  margin-top: 0;
}
.login-wrapper{
  max-width: 552px;
}
.login-wrapper button{
  max-width: 256px;
  margin: 0 auto;
  margin-top: 20px;
}

</style>
